import type { SelectableFilterItem } from '~/features/catalog/components/filter/MultiSelectionItemFilter';
import type { ISearchFilterIdItemDto } from '~/dtos/hub/hub.models.generated';
import { Checkbox } from '~/common/components/ui/checkbox';
import { Label } from '~/common/components/ui/label';
import { formatNumber } from '~/common/utils/numberUtil';
import { useTranslation } from 'react-i18next';

export interface FilterEntriesItemProps {
  selectableItem: SelectableFilterItem<ISearchFilterIdItemDto>;
  onItemSelectionChanged: (id: number) => void;
}

export function FilterEntriesItem({ selectableItem, onItemSelectionChanged }: Readonly<FilterEntriesItemProps>) {
  const checkboxId = `checkbox-${selectableItem.item.id}`;
  const { i18n } = useTranslation();

  const handleCheckboxChange = () => {
    onItemSelectionChanged(selectableItem.item.id);
  };

  return (
    <Label
      htmlFor={checkboxId}
      className={'flex items-center pr-2 h-full cursor-pointer hover:bg-neutral-100 pl-1 py-2'}
    >
      <Checkbox
        id={checkboxId}
        checked={selectableItem.selected}
        className={'mr-2'}
        data-testid={`dropdownfilter-entry-${selectableItem.label}`}
        onCheckedChange={() => {
          handleCheckboxChange();
        }}
      />
      <div className={'text-base grow'}>{selectableItem.label}</div>
      {selectableItem.item.count > 0 && (
        <div className={'text-xs text-secondary'}>{formatNumber(selectableItem.item.count, i18n.language, 0)}</div>
      )}
    </Label>
  );
}
